<script setup lang="ts">
import { computed, ref } from "vue";

import AvatarUpload from "~/components/AvatarUpload.vue";
import Avatar from "~/components/dumb/Avatar.vue";
import TextInput from "~/components/dumb/TextInput.vue";
import { USER_KIND_CUSTOM, USER_KIND_USER } from "~/constants/userKinds";
import type { User } from "~/shared/types";

const props = defineProps<{
  row: User;
  onUpdateName?: (name: string) => void;
}>();

const isAgent = computed(() => props.row.kind !== USER_KIND_USER);
const isEditable = computed(() => props.row.kind === USER_KIND_CUSTOM);

const inputRef = ref<InstanceType<typeof TextInput> | null>(null);

const startEditing = () => inputRef.value?.startEditing();

defineExpose({
  startEditing,
});
</script>

<template>
  <div class="my-1 flex items-center">
    <AvatarUpload v-if="isEditable" :agent="row" kind="agent" class="my-1 mr-2" />
    <Avatar v-else :user="row" class="my-1 mr-2 size-10 shrink-0" />

    <div class="flex items-center gap-2 overflow-hidden" :class="isEditable ? 'ml-px' : 'ml-2'">
      <div class="flex flex-col overflow-hidden">
        <template v-if="!isEditable">
          <span :title="row.name || row.email" class="flex-1 truncate pr-2 text-md">
            {{ row.name || row.email }}
          </span>
          <span v-if="row.name && !isAgent" :title="row.email" class="flex-1 select-text truncate text-sm text-lt">
            {{ row.email }}
          </span>
        </template>
        <TextInput
          v-else
          ref="inputRef"
          :text="row.name"
          editable
          text-base
          dblclick-to-edit
          padded
          placeholder="Agent name"
          class="text-md"
          @save="onUpdateName" />
      </div>
    </div>
  </div>
</template>
